import type { InputTargetConversation } from "@/api/conversation-targets";
import { Icons } from "@/components/ui/icons";
import { conversationDisplayName } from "@/lib/conversation-display";
import { workerStatusLabel } from "./conversation-status";
import { InputTargetRowIcon } from "./input-target-row-icon";

/** Kind icon, name, ticket (or project) and worker status of one chat or sub-agent target. */
export function InputTargetRowContent({
  row,
  current = false,
  standalone = false,
}: {
  row: InputTargetConversation;
  current?: boolean;
  standalone?: boolean;
}) {
  const subagent = row.target_kind === "subagent";
  const status =
    subagent && row.native_subagent
      ? workerStatusLabel(row.native_subagent.status)
      : null;
  // Manual chats have no task, so they show their project instead of a ticket.
  const scope = row.task?.ticket_display ?? row.project_name;
  return (
    <>
      {standalone ? <InputTargetRowIcon row={row} /> : (
        subagent ? <Icons.Bot className="h-3.5 w-3.5 shrink-0 text-muted" aria-hidden="true" />
          : <Icons.MessageCircle className="h-3.5 w-3.5 shrink-0 text-muted" aria-hidden="true" />
      )}
      <span className="min-w-0 truncate text-appkit-small font-medium text-primary">
        {standalone ? "@" : ""}{conversationDisplayName(row)}
      </span>
      {scope ? (
        <span className={standalone ? "ml-auto shrink-0 whitespace-nowrap text-appkit-mini text-muted" : "shrink-0 whitespace-nowrap text-appkit-mini text-muted"}>
          {scope}
        </span>
      ) : null}
      {status || current ? (
        <span className="ml-auto flex shrink-0 items-center gap-1.5 whitespace-nowrap text-appkit-mini font-medium tabular-nums text-muted">
          {status}
          {current ? (
            <Icons.Check
              className="h-3.5 w-3.5 text-primary"
              aria-hidden="true"
            />
          ) : null}
        </span>
      ) : null}
    </>
  );
}
